import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.split";
import _getIterator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/get-iterator";
import _toConsumableArray from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as types from "@/store/constants/types";
import textContent from "@/components/textContent/textContent.vue";
import CircleRingChart from "@/components/circleRingChart/circleRingChart.vue";
import ResetDone from "@/components/resetDone/resetDone.vue";
import { routerIncludeTimes } from "@/utils/routerStackUtil";
import GeneralUtilsHelper from "@/utils/generalUtils";
import vipMask from "@/components/vipMask/vipMask.vue";
import { i18n } from "@/i18n/i18n-setup";

var Futrue =
/*#__PURE__*/
function (_Vue) {
  _inherits(Futrue, _Vue);

  function Futrue() {
    var _this;

    _classCallCheck(this, Futrue);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Futrue).apply(this, arguments));
    _this.showMask = false;
    _this.workList = [i18n.t("personal_futrue.future.work_list[0]"), i18n.t("personal_futrue.future.work_list[1]"), i18n.t("personal_futrue.future.work_list[2]"), i18n.t("personal_futrue.future.work_list[3]"), i18n.t("personal_futrue.future.work_list[4]"), i18n.t("personal_futrue.future.work_list[5]"), i18n.t("personal_futrue.future.work_list[6]"), i18n.t("personal_futrue.future.work_list[7]"), i18n.t("personal_futrue.future.work_list[8]"), i18n.t("personal_futrue.future.work_list[9]"), i18n.t("personal_futrue.future.work_list[10]"), i18n.t("personal_futrue.future.work_list[11]"), i18n.t("personal_futrue.future.work_list[12]"), i18n.t("personal_futrue.future.work_list[13]"), i18n.t("personal_futrue.future.work_list[14]"), i18n.t("personal_futrue.future.work_list[15]"), i18n.t("personal_futrue.future.work_list[16]")];
    _this.recommondWorkList = [];
    _this.randomWorkList = [];
    return _this;
  } // private isVip = false;


  _createClass(Futrue, [{
    key: "randomWork",
    // get maxHeightStr() {
    //   console.log(this.isVip);
    //   return this.isVip ? 'auto' :this.maxHeight+'px';
    // }
    value: function randomWork(val, oldVal) {
      if (val) {
        this.randomWorkList = [];
        this.recommondWorkList = [];

        var cloneList = _toConsumableArray(this.workList);

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(val.profession.split(" or ")), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var j = _step.value;
            this.recommondWorkList.push(j.trim());

            var _i = cloneList.indexOf(j.trim());

            if (_i > 0) {
              cloneList.splice(_i, 1);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        for (var m = 0; m < 4; m++) {
          var _this$randomWorkList;

          var i = Math.floor(Math.random() * cloneList.length);

          (_this$randomWorkList = this.randomWorkList).push.apply(_this$randomWorkList, _toConsumableArray(cloneList.splice(i, 1)));
        }
      }
    }
  }, {
    key: "rateUsFn",
    value: function () {
      var _rateUsFn = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var rateUsResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rateUs();

              case 2:
                rateUsResult = _context.sent;

                if (rateUsResult) {
                  this.isShowMask(true);
                  this.$emit("rateUsSuccess");
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function rateUsFn() {
        return _rateUsFn.apply(this, arguments);
      }

      return rateUsFn;
    }()
  }, {
    key: "isShowMask",
    value: function isShowMask() {
      var rateUsChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isVip || rateUsChange) {
        this.showMask = false;
      } else {
        this.showMask = true;
      }
    }
  }, {
    key: "goToVipCenter",
    value: function goToVipCenter() {
      this.routerPush({
        name: "vipcenter",
        query: {
          type: "personalFutrue",
          key: "person_future",
          byClick: true
        },
        params: {
          routerTransition: "up"
        }
      });
    }
  }, {
    key: "calcSwiperHeihgt",
    value: function calcSwiperHeihgt() {}
  }, {
    key: "done",
    value: function done() {
      var backNum = routerIncludeTimes("personalFutrue");
      this.routerGoBack(-backNum);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.personalFuture();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.isShowMask();
    }
  }, {
    key: "activated",
    value: function activated() {
      this.isShowMask(); // this.isVip = GeneralUtilsHelper.isVip();
    }
  }, {
    key: "isVip",
    get: function get() {
      return GeneralUtilsHelper.isVip();
    }
  }, {
    key: "leftPos",
    get: function get() {
      return this.futrueData.happiness + "%";
    }
  }]);

  return Futrue;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], Futrue.prototype, "routerPush", void 0);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], Futrue.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.PERSONAL_FUTRUE)], Futrue.prototype, "personalFuture", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], Futrue.prototype, "futrueData", void 0);

tslib_1.__decorate([Prop({
  default: null
})], Futrue.prototype, "nowData", void 0);

tslib_1.__decorate([Prop()], Futrue.prototype, "maxHeight", void 0);

tslib_1.__decorate([Action(types.RATE_US)], Futrue.prototype, "rateUs", void 0);

tslib_1.__decorate([Watch("futrueData")], Futrue.prototype, "randomWork", null);

tslib_1.__decorate([Emit("calcSwiperHeihgt")], Futrue.prototype, "calcSwiperHeihgt", null);

Futrue = tslib_1.__decorate([Component({
  components: {
    textContent: textContent,
    CircleRingChart: CircleRingChart,
    ResetDone: ResetDone,
    vipMask: vipMask
  }
})], Futrue);
export default Futrue;